import { TextField, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ChangeEvent, useCallback } from "react";
import { useAnswer } from "src/context/AnswerProvider";
import { useQuestions } from "src/context/QuestionsProvider";
import ChoiceOption from "../ChoiceOption";
import { QuestionOption } from "src/api/types";
import { useTranslation } from "react-i18next";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";

const mapSkipNextQuestion: Record<string, boolean> = {
  FORM_SELECTION: true,
};

const SingleChoice = () => {
  const options = useQuestions((q) => q.options ?? []);
  const followUp = useQuestions((q) => q.follow_up);
  const followUpCaption = useQuestions((q) => q.follow_up_caption);
  const tag = useQuestions((q) => q.tag);
  const slug = useQuestions((q) => q.slug);
  const { answers, setAnswers, details, setDetails } = useAnswer();
  const { submitAnswer, nextQuestion } = useSubmitAnswers();
  const page = "questions";
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (option: QuestionOption) => {
      setAnswers([option.value]);

      if (option.value.includes("No") || !followUp) {
        submitAnswer(
          [option.value],
          option.next_question ?? undefined,
          mapSkipNextQuestion[tag || ""],
        );

        if (tag === "FORM_SELECTION") {
          nextQuestion({ form: option.value });
        }
      }
    },
    [followUp, nextQuestion, setAnswers, submitAnswer, tag],
  );

  const handleDetails = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setDetails(event.target.value);
    },
    [setDetails],
  );

  return (
    <>
      <Stack gap="8px">
        {options.map((option) => (
          <ChoiceOption
            option={option}
            key={option.value}
            onSelect={handleSelect}
          />
        ))}
      </Stack>
      {followUp && answers[0] === "Yes" && (
        <Stack>
          {followUpCaption != null ? (
            <Typography variant="subtitle1">
              {t(`${page}.${slug}.followup.caption`, followUpCaption)}
            </Typography>
          ) : null}
          <TextField
            value={details || ""}
            onChange={handleDetails}
            fullWidth
            multiline
            minRows={5}
            placeholder={t(`${page}.placeholder.text`)}
            style={{ borderRadius: "8px" }}
          />
        </Stack>
      )}
    </>
  );
};

export default SingleChoice;
